import { useCallback } from 'react';

import { useAppStore } from '@/modules/app/store/useAppStore';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useAppMetaStore } from '@/modules/floorplanV2/store/project/projectState';
import { useFpsStore } from '@/modules/floorplanV2/store/useFpsStore';
import { useActiveFlowStore } from '@/modules/flowsV2/store/useActiveFlowStore';
import { useActiveDistconStore } from '@/modules/connections/store/useActiveDistconStore';
import { useCopyPasteStore } from '@/modules/copy/store/useCopyPasteStore';
import { useVehicleStore } from '@/modules/vehicles/store/useVehicleStore';
import { useLoadCarrierStore } from '@/modules/loadCarriers/store/useLoadCarrierStore';
import { useOrderProfileStore } from '@/modules/orderProfile/store/useOrderProfileStore';
import { useReferenceImageUIStore } from '@/modules/referenceImage/store';
import { usePointCloudUIStore } from '@/modules/pointCloud/store';

export const useResetStores = () => {
  const resetStores = useCallback(() => {
    useAppStore.getState().reset();
    useFloorplanDesignStore.getState().reset();
    useAppMetaStore.getState().reset();
    useFpsStore.getState().reset();
    useActiveFlowStore.getState().reset();
    useActiveDistconStore.getState().reset();
    useCopyPasteStore.getState().reset();
    useVehicleStore.getState().reset();
    useLoadCarrierStore.getState().reset();
    useOrderProfileStore.getState().reset();
    useReferenceImageUIStore.getState().reset();
    usePointCloudUIStore.getState().reset();
  }, []);

  return { resetStores };
}
